import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = {
  class: "anchor fw-bolder mb-5",
  id: "setup_skeleton"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Setup skeleton ")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" To get started with theme skeleton you should change router path to new path for clean router file, which is already added inside "),
  /*#__PURE__*/_createVNode("code", null, "src/router"),
  /*#__PURE__*/_createTextVNode(" folder. Change router path inside file main.js to the following path: ")
], -1)
const _hoisted_7 = { class: "pb-5" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Second thing what you need to change is our menus, in Metronic 8 we have two types of menu in header and aside bar. ", -1)
const _hoisted_9 = { class: "py-5" }
const _hoisted_10 = { class: "d-flex align-items-center rounded py-5 px-5 bg-light-info" }
const _hoisted_11 = { class: "svg-icon svg-icon-3x svg-icon-info me-5" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "text-gray-600 fw-bold fs-5" }, [
  /*#__PURE__*/_createTextVNode(" Main menu is generated from the file "),
  /*#__PURE__*/_createVNode("code", null, "src/core/config/MainMenuConfig.ts"),
  /*#__PURE__*/_createTextVNode(". Header menu is generated inside "),
  /*#__PURE__*/_createVNode("code", null, "src/layout/header/Menu.vue"),
  /*#__PURE__*/_createTextVNode(" and the aside menu is generated inside "),
  /*#__PURE__*/_createVNode("code", null, "src/layout/aside/Menu.vue"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" To get started with clean menu, you can update menu config path in both "),
  /*#__PURE__*/_createVNode("code", null, "Menu.vue"),
  /*#__PURE__*/_createTextVNode(" files from "),
  /*#__PURE__*/_createVNode("code", null, "src/core/config/MainMenuConfig.ts"),
  /*#__PURE__*/_createTextVNode(" to the following code: ")
], -1)
const _hoisted_14 = { class: "pb-5" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`import MainMenuConfig from "@/core/config/CleanMainMenuConfig";`))
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Now you can delete unneeded page view files from folder "),
  /*#__PURE__*/_createVNode("code", null, "src/views")
], -1)
const _hoisted_17 = { class: "py-5" }
const _hoisted_18 = {
  class: "anchor fw-bolder mb-5",
  id: "setup_api"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Setup API ")
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" In theme we are using axios-adapter to make http requests. In the real app requests will be send to real server api so you can remove MockService initialization from the file "),
  /*#__PURE__*/_createVNode("code", null, "main.ts"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_21 = { class: "pb-5" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" And change baseURL property of axios to your api url in file "),
  /*#__PURE__*/_createVNode("code", null, "src/core/services/ApiService.ts"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_23 = { class: "pb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h1", _hoisted_4, [
          _createVNode(_component_router_link, { to: "#setup_skeleton" }),
          _hoisted_5
        ]),
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_CodeHighlighter, { lang: "javascript" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`import router from "@/router/clean.ts";`), 1)
            ]),
            _: 1
          })
        ]),
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("span", _hoisted_11, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
            ]),
            _hoisted_12
          ])
        ]),
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_CodeHighlighter, { lang: "javascript" }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _hoisted_16
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("h1", _hoisted_18, [
          _createVNode(_component_router_link, { to: "#setup_api" }),
          _hoisted_19
        ]),
        _hoisted_20,
        _createVNode("div", _hoisted_21, [
          _createVNode(_component_CodeHighlighter, { lang: "javascript" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`MockAdapter.init(app);`), 1)
            ]),
            _: 1
          })
        ]),
        _hoisted_22,
        _createVNode("div", _hoisted_23, [
          _createVNode(_component_CodeHighlighter, { lang: "javascript" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`ApiService.vueInstance.axios.defaults.baseURL = "http://your-url";`), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}